import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_503: DocMigration = {
  maxSchemaVersion: "0.0.503",
  description: "Add referencedEntityType to entity settings",
  apply(json: any): any {
    // Build a map of entityId -> entityType
    const entityTypeMap: Record<string, string> = {};

    for (const id in json.dormers) {
      entityTypeMap[id] = "DORMER";
    }
    for (const id in json.roofOpenings) {
      entityTypeMap[id] = "ROOF_OPENING";
    }
    for (const id in json.openings) {
      entityTypeMap[id] = "OPENING";
    }
    for (const id in json.roofs) {
      entityTypeMap[id] = "ROOF";
    }
    for (const id in json.rooms) {
      entityTypeMap[id] = "ROOM";
    }

    // Apply the entity type to each entity setting
    for (const id in json.entitySettings) {
      const entitySetting = json.entitySettings[id];

      if (entitySetting.referencedEntityType) {
        continue;
      }

      // If the entity id is not in the entity type map, delete the entity setting as it is invalid
      if (!entityTypeMap[entitySetting.entityId]) {
        delete json.entitySettings[id];
        continue;
      }

      entitySetting.referencedEntityType = entityTypeMap[entitySetting.entityId];
    }

    return json;
  },
};

export default migration_0_0_503;
